import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../i18n';
import ToolTip from '../../components/common/ToolTip/ToolTip';
import { ProfileOverviewState } from '../../redux/reducers/getProfile/getProfileOverviewReducer';
import { selectProfileGetOverview } from '../../redux/selectors/exportSelectorPaths';
import { formatCurrency, formatPercentage } from '../../utils/formatter';
import './Summary.css'
interface IncomeExpenseSummaryProps {
    currencySymbol: string;
    totalHeader: string;
    tableData: Record<string, number>;
    separateTables?: boolean;
    isValueNegative?: boolean;
    percentageData?: Record<string, number>;
    tooltip?: JSX.Element | string | null;
    headerPercent?: number;
}

export default function IncomeExpenseSummary(props: IncomeExpenseSummaryProps): JSX.Element {

    const { t } = useTranslation(['navigation', 'pie']);
    const profileOverview: ProfileOverviewState = useSelector(selectProfileGetOverview)
    const incomeAttributeLookupType = profileOverview.profile.profile_type_code.toLowerCase()

    const buildTable = (): JSX.Element | JSX.Element[] => {
        const rowArr: JSX.Element[] = [];
        Object.keys(props.tableData).forEach((key, index) => {
            const percentage = props.percentageData?.[key];
            const row = <tr key={`income-expense-row-${index}`}>
                <td>
                    {(key === "grandTotal") ? props.totalHeader : (key === "cost" ? t("costs.totalCapitalExpSummary", { ns: 'pie' }) : (key === "motelRevenue" ? t("operatingRevenue", { ns: 'navigation' }) :
                        ((key === "fixedCharges" && ["rho", "ltc", "mtl"].includes(incomeAttributeLookupType)) ? t("GLF.charges", { ns: 'navigation' }) : ((key === "revenue" && incomeAttributeLookupType === "ltc") ?
                            t("operatingRevenue", { ns: 'navigation' }) : ((key === "expenses" && incomeAttributeLookupType === "rho") ? t("operatingExpenses", { ns: 'navigation' }) : t(key, { ns: 'navigation' }))))))}
                    {
                        props.tooltip &&
                        <ToolTip tooltipClassName="fit-content-width-tooltip"
                            contents={<FontAwesomeIcon icon={faCircleInfo} className="info-tooltip-icon" />}>
                            {props.tooltip}
                        </ToolTip>
                    }
                </td>
                <td className={`summary-currency ${props.isValueNegative ? "red-font" : ""}`}>
                    <div>
                        <span>{props.currencySymbol + " " + formatCurrency(props.tableData[key], i18n.language)}</span>
                        {percentage !== undefined && <span className='summary-percentage airp-badge badge-green'>{formatPercentage(percentage)}</span>}
                        {(key === "grandTotal" && props.headerPercent) &&
                            <span className='summary-percentage airp-badge badge-green'>
                                {formatPercentage(props.headerPercent)}
                            </span>
                        }
                    </div>
                </td>
            </tr>;
            props.separateTables ? rowArr.push(<div className='summary-section-container' key={`income-expense-section-${index}`}><table className='summary-table income-expense-summary-table' role='presentation'><thead className='invisible-header'><tr><th></th></tr></thead><tbody>{row}</tbody></table></div>) : rowArr.push(row);
        })
        if (!props.separateTables) {
            const lastTr = rowArr.pop();
            rowArr.splice(0, 0, lastTr as JSX.Element);

        }
        const table = props.separateTables ? rowArr : <div className='summary-section-container'><table className='summary-table income-expense-summary-table' role='presentation'><thead className='invisible-header'><tr><th></th></tr></thead><tbody>{rowArr}</tbody></table></div>

        return table;
    }

    return (
        <>
            {buildTable()}
        </>
    )
}
